import {
  STANDARD_MENU_FETCHING,
  STANDARD_MENU_FAILED,
  STANDARD_MENU_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case STANDARD_MENU_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case STANDARD_MENU_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case STANDARD_MENU_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
